import React, { useEffect } from "react";
import BaibolLogo from "../../components/BaibolLogo/BaibolLogo";
import BlackVersionButton from "./BlackVersionButton/BlackVersionButton";
import HeaderDesktop from "./HeaderDesktop/HeaderDesktop";
import HeaderMobile from "./HeaderMobile/HeaderMobile";
import GetMoney from "./GetMoney/GetMoney";
import PayOffTheLoan from "./PayOffTheLoan/PayOffTheLoan";

import finalist2022 from '../../assets/img/icons/finalist_2022.svg';

const Header: React.FC = () => {

    useEffect(() => {
        const mobileScrollHandler = () => {
            const headerMobile = document.querySelector('.header__mobile');
            const headerWrapper = document.querySelector('.header__wrapper') as HTMLElement;
            const main = document.querySelector('main');
            const topBlock = document.querySelector('.top-block') as HTMLElement;

            if (headerMobile && headerWrapper && main && topBlock) {
                if (window.pageYOffset >= 100) {
                    headerMobile.classList.add('scroll');
                    headerWrapper.style.margin = "22px 10px 24px";
                    topBlock.style.display = 'none';
                } else {
                    headerMobile.classList.remove('scroll');
                    headerWrapper.style.margin = "9px 10px 25px";
                    main.style.marginTop = '118px';
                    topBlock.style.display = 'flex';
                }
            }
        }

        const desktopScrollHandler = () => {
            const headerBottom = document.querySelector('.header__bottom') as HTMLElement;
            const header = document.querySelector('header');
            const main = document.querySelector('main');

            if (headerBottom && header && main) {
                if (window.pageYOffset >= 100) {
                    headerBottom.style.display = 'none';
                    header.style.cssText = 'position: fixed; background: #fff; z-index: 10000; top: 0; left: 0;';
                    main.style.marginTop = '151px';
                } else {
                    headerBottom.style.display = 'grid';
                }
            }
        }

        if (window.innerWidth <= 540) {
            window.addEventListener('scroll', mobileScrollHandler);
        } else {
            window.addEventListener('scroll', desktopScrollHandler);
        }

        return () => {
            if (window.innerWidth <= 540) {
                window.removeEventListener('scroll', mobileScrollHandler);
            } else {
                window.removeEventListener('scroll', desktopScrollHandler);
            }
        }
    });

    return (
        <header>
            <div className="header__wrapper">
                <div className="header__top">
                    <div className="header__logo">
                        <BaibolLogo width={130} height={30} />
                        <img src={finalist2022} alt="Финалист рейтинга работодателей РФ 2022" />
                    </div>
                    <div className="header__phone__lang__sv">
                        <div className="header__phone">
                            <a href="tel:88005505757" data-title="Ежедневно с 9:00 до 21:00 Бесплатный звонок по России">8 (800) 550 57 57</a>
                        </div>
                        <BlackVersionButton />
                    </div>
                    <div className="header__get__repay__money">
                        <GetMoney className="get__money__btn" />
                        <PayOffTheLoan />
                    </div>
                </div>
                <HeaderDesktop />
                <HeaderMobile />
            </div>
        </header >
    );
}

export default Header;